import {createStore, applyMiddleware, Store, AnyAction, Middleware} from 'redux'
import createSagaMiddleware from 'redux-saga'
import {createLogger} from 'redux-logger'
import {actions as appActions} from './modules/app'
import rootSaga from './rootSaga'
import createRootReducer from './rootReducer'
import {routerMiddleware} from 'connected-react-router'
import environment from '../environment'
import Api from '../api/reactpt'
import {createBrowserHistory} from 'history'
import {HttpError} from 'src/api/Api/http'
import {actions as authActions} from 'src/redux/modules/auth'
import _ from 'lodash'

export const history = createBrowserHistory()

export const shouldLogUserOut = (error: Error) =>
  _.includes([HttpError.Unauthorized.message, HttpError.Forbidden.message], error.message)

const configureStore = function (): Store<any, AnyAction> {
  console.info(`Using environment: ${environment.apiUrl}`)
  const api = new Api(environment)
  const sagas = createSagaMiddleware({
    context: {api},
    onError: (error: Error) => {
      console.warn('Error', error)
      sagas.run(rootSaga)
      if (shouldLogUserOut(error)) {
        store.dispatch(authActions.logout())
      }
      store.dispatch(appActions.init())
      store.dispatch(appActions.showError({error}))
    },
  })

  const logger = createLogger({collapsed: true, diff: true})
  const router = routerMiddleware(history)
  const middlewares: Middleware[] = [sagas, logger, router]

  const store: Store<any, AnyAction> = createStore(
    createRootReducer(history),
    applyMiddleware(...middlewares),
  )
  sagas.run(rootSaga)
  store.dispatch(appActions.init())

  return store
}
export default configureStore
